module.exports = __webpack_public_path__ + "static/media/logo_notification.c638eae7.svg";